<template>
  <div>
    <section class="main flex flex-wrap w-full h-screen bg-black" :class="{ frosted : modalIsActive }">
        <div class="w-half text-white">
          <nav-breadcrumb :parent="parent" :grandparent="grandparent"></nav-breadcrumb>
          <template v-if="hasPage">
            <div class="relative det__gallery-ctn">
              <template v-if="hasGallery">
                <template v-if="gallery.length > 1 && showFlickity">
                  
                  <flickity v-if="gallery && gallery.length > 0" ref="flickity" :options="flickityOptionsInline" class="det__flickity">
                    <div v-for="image in gallery" :key="image.title" class="carousel-cell">
                      <img :data-flickity-lazyload="image.url" :alt="image.title">
                    </div>
                  </flickity>

                </template>
                <template v-else>
                  <div class="imagebox relative bg-cover bg-center bg-no-repeat flex items-center justify-end" :style="galleryBackground"></div>
                </template>
              </template>
                
              <button v-if="hasGallery && showGalleryLaunchButton" @click="toggleModal" class="det__lg-btn absolute pin-b pin-r z-10 mb-8 mr-6 p-3 text-sm rounded uppercase text-white text-data sans tracking-wide">Launch
                Gallery</button>
              <!-- <img v-if="!hasGallery" class="animated fadeInLeft fast" src="@/assets/images/slideshow-fallback.png" alt="CAC"> -->
            </div>
            <div class="flex p-8">
              <nav-sidebar class="overflow-y-scroll det__scroll-ctn-hasgallery det__scroll-ctn" v-if="hasNavSidebar" :siblings="siblings"></nav-sidebar>
              <div :class="['text-xl sans', hasNavSidebar ? 'w-half' : 'w-4/5 mx-auto']">
                <div v-if="hasPage" class="z-50" :class="[{ 'det__scroll-ctn-hasgallery': hasGallery }, {'overflow-y-auto pr-6 scrolling-touch pb-20 det__scroll-ctn': hasNavSidebar}, {'mt-6':!hasNavSidebar}]">
                  <div class="p-mb leading-normal font-light" v-html="content.body"></div>     
                  <p class="sans border-t mt-8 pt-2 text-sm" v-if="content.dataCaption">{{ content.dataCaption }}</p>
                  <related-content v-if="hasRelated" :related="relatedContent"></related-content>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            Loading..
          </template>
        </div>

        <map-sidebar :maps="maps" :osc="oscCueId"></map-sidebar>
        
      </section>
      <!-- overlay -->
      <transition name="fade" mode="out-in">
        <keep-alive>
          <modal-overlay v-if="modalIsActive" @close="toggleModal">
            <div class="flex">
              <div class="w-4/5 text-white pr-20 self-center">
                <flickity v-if="hasGallery" ref="flickity-l" :options="flickityOptionsOverlay">
                  <figure v-for="image in gallery" :key="image.title" class="carousel-cell">
                    <img :data-flickity-lazyload="image.url_large" :alt="image.title">
                    <figcaption class="pt-2">
                      <p v-if="image.credit" class="text-white text-left text-xs sans">{{ image.credit }}</p>
                      <p v-if="image.caption" class="text-white text-left pt-4 sans">{{ image.caption }}</p>
                    </figcaption>
                  </figure>
                </flickity>
              </div>
              <div class="w-1/5 text-white text-left">
                <p @click="toggleModal" class="text-42 cursor-pointer text-white uppercase text-center tracking-wide mb-32">Close</p>
                <div class="modal__body-wrap relative">
                  <div class="modal__body-content overflow-auto scrolling-touch pr-6">
                    <div class="sans leading-normal p-mb" v-html="content.body"></div>
                    <p class="sans border-t mt-8 pt-2 text-sm leading-none" v-if="content.dataCaption">{{ content.dataCaption }}</p>
                    <related-content v-if="hasRelated" :related="relatedContent"></related-content>
                  </div>
                </div>
              </div>
            </div>
          </modal-overlay>
        </keep-alive>
      </transition>
    </div>
</template>
<script>
  import NavBreadcrumb from '../../components/NavBreadcrumb'
  import NavSidebar from '../../components/NavSidebar'
  import MapSidebar from '../../components/maps/MapSidebar'
  import ModalOverlay from '../../components/ModalOverlay'
  import RelatedContent from '../../components/RelatedContent'
  import Flickity from 'vue-flickity'

  export default {
    name: 'DetailPage',
    components: {
      'nav-breadcrumb': NavBreadcrumb,
      'nav-sidebar': NavSidebar,
      'map-sidebar': MapSidebar,
      'flickity': Flickity,
      'modal-overlay': ModalOverlay,
      'related-content': RelatedContent,
      Flickity
    },

    data: function () {
      return {
        modalIsActive: false,
        showGalleryLaunchButton: false,
        showFlickity: false
      }
    },

    watch: {
      /* This watch, null/reinit cycle resets the sub detail component
      on each url change. */
      currentUri (val) {
        this.reinitImages()
      }
    },

    activated () {
      this.reinitImages()
    },

    mounted () {
      if (this.page === false) {
        this.$router.push('/')
      }

      this.reinitImages()
    },

    methods: {
      reinitImages () {
        this.showFlickity = false
        setTimeout(() => {
          this.showFlickity = true
        }, 1500)
      },

      toggleModal () {
        this.modalIsActive = !this.modalIsActive
      }
    },

    computed: {
  
      galleryBackground () {
        let str = ''
        if (this.gallery[0]) {
          str = 'width: 960px; height:395px; background: url(' + this.gallery[0].url + ') center center / cover no-repeat;'
        }
        return str
      },

      currentUri () {
        return this.$route.path
      },

      flickityOptionsOverlay () {
        return {
          prevNextButtons: false,
          wrapAround: true,
          lazyLoad: 1,
          pageDots: this.galleryModalHasDots
        }
      },
  
      flickityOptionsInline () {
        return {
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          lazyLoad: 1
        }
      },

      oscCueId () {
        if (this.content) {
          if (this.content.oscCueId !== null) return this.content.oscCueId
        }
        return null
      },

      hasGallery () {
        if (!this.gallery) return false
        return this.gallery.length > 0
      },

      galleryModalHasDots () {
        return this.gallery.length > 1
      },
  
      hasNavSidebar () {
        return this.siblings !== null
      },

      hasRelated () {
        if (this.content && this.content.relatedEntries) {
          if (this.content.relatedEntries.length > 0) return true
        }
        return false
      },

      relatedContent () {
        if (this.content.relatedEntries) return this.content.relatedEntries
        return null
      },

      allContent () {
        return this.$store.getters['pages/content']
      },

      page () {
        let page = false
        this.allContent.forEach((item) => {
          if (item.uri === this.uri) {
            page = item
          }
        })

        return page
      },

      content () {
        if (this.page) {
          return this.page.content
        }

        return false
      },

      body () {
        if (!this.content) return null
        return this.content.body
      },

      maps () {
        if (!this.content) return null
        return this.content.maps
      },

      gallery () {
        if (!this.content) return null
        return this.content.gallery
      },

      uri () {
        return this.$route.path
      },

      title () {
        if (this.page) {
          return this.page.title
        }

        return ''
      },

      hasPage () {
        return (this.page != null)
      },

      toLanding () {
        return {
          name: 'LandingPage'
        }
      },

      parent () {
        if (this.page.parent_id == null) return false

        let parent = false
        this.allContent.forEach((item) => {
          if (item.id === this.page.parent_id) {
            parent = item
          }
        })

        return parent
      },

      grandparent () {
        if (this.parent.parent_id == null) return false

        let parent = false
        this.allContent.forEach((item) => {
          if (item.id === this.parent.parent_id) {
            parent = item
          }
        })

        return parent
      },

      siblings () {
        if (this.parent === false) return null
        if (this.grandparent === false) return null
  
        let siblings = []
        this.allContent.forEach((item) => {
          if (item.parent_id === this.parent.id) {
            siblings.push(item)
          }
        })

        return siblings
      }
    }
  }
</script>
<style>
    .carousel-cell {
      width: 100%; 
      height: 400px;
    }
    .flickity-page-dots .dot {
      background: #fff;
    }
    .flickity-button, .flickity-button:hover {
      background: transparent;
    }
    .flickity-button-icon {
      fill: white;
    }
    .vue-slider, .vue-slider-process {
      background: linear-gradient(to bottom, rgba(248,216,77,1) 0%,rgba(244,132,46,1) 54%,rgba(233,69,72,1) 100%);
    }
    .mapbox, .imagebox {
      transition: background-image 1s ease-in-out;;
    }
  </style>
  